import * as React from "react";

function SvgIcons8IdeaWindow(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M4 4v24h19.89c.064.299.108.62.11 1.004l.004.996H25v1.332l2.016.668L29 31.332V30h.99l.01-.99c.013-1.288.396-2.005.873-2.83.477-.826 1.12-1.798 1.127-3.176.01-2.441-1.753-4.43-4-4.899V4H4zm2 2h20v4H6V6zm1 1v2h2V7H7zm3 0v2h2V7h-2zm3 0v2h2V7h-2zm-7 5h20v6.1a5.019 5.019 0 00-3.998 4.894c-.01 1.289.533 2.223.998 3.006H6V12zm20.996 8c1.621.006 3.012 1.31 3.004 2.996-.004.773-.345 1.296-.857 2.182-.398.687-.776 1.656-.97 2.822h-2.347c-.193-1.158-.576-2.122-.976-2.803-.517-.878-.857-1.392-.85-2.187V23a2.983 2.983 0 012.996-3z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8IdeaWindow);
